<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>hotel</md-icon>
        </div>
        <h4 class="title">Accommodation</h4>
      </md-card-header>
      <md-card-content>
        <md-toolbar md-elevation="0" class="md-transparent md-dense">
          <div class="md-toolbar-section-end">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click="newAccom"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top">Add Accommodation</md-tooltip>
            </md-button>
          </div>
        </md-toolbar>
        <md-table v-model="accoms" @md-selected="viewAccom">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Company">
              <a href="#" @click.stop="viewAccom(item)">{{ item.company }}</a>
            </md-table-cell>
            <md-table-cell md-label="Country">
              {{ item.country }}
            </md-table-cell>
            <md-table-cell class="text-right">
              <md-button
                class="md-just-icon md-simple md-danger "
                @click.stop="deleteAccom(item)"
              >
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">Delete</md-tooltip>
              </md-button>
              <md-button
                class="md-just-icon md-simple md-success"
                @click.stop="viewAccom(item)"
              >
                <md-icon>visibility</md-icon>
                <md-tooltip md-direction="top">View</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <md-table-empty-state
            md-label="Let's Sleep..."
            :md-description="`Add Accommodation.`"
          >
            <md-button class="md-primary md-raised" @click="newAccom"
              >Add Accommodation</md-button
            >
          </md-table-empty-state>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: ["accoms"],

  data() {
    return {};
  },

  components: {},

  methods: {
    newAccom() {
      this.$emit("addAccom");
    },

    viewAccom(accom) {
      this.$emit("viewAccom", accom);
    },

    deleteAccom(accom) {
      this.$emit("deleteAccom", accom);
    }
  },

  watch: {},

  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-switch {
  margin: 0;
}
</style>
